import { render, staticRenderFns } from "./PageHeadline.vue?vue&type=template&id=5386b34d&"
import script from "./PageHeadline.vue?vue&type=script&lang=js&"
export * from "./PageHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports